import style from 'styled-components'
import css from '@styled-system/css'
import { Box } from '@careguide/theme'

export const Container = style(Box).attrs({ mt: 4, display: 'flex' })`
  flex-direction: row;
`

export const Photo = style.img`
  border-radius: 5%;
  cursor: pointer;
  ${css({
    backgroundColor: 'gray.0',
    mr: 16,
  })}
`
